import { Icon } from '../../../components/Icon';
import { useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';
import { NewChatPrompt } from './NewChatPrompt';

interface ChatPluginStarterProps {
  starters: string[];
  isDisabled: boolean;
  useInfo: boolean;
  onClick: (text: string) => void;
}

export const ChatPluginStarter: React.FC<ChatPluginStarterProps> = ({ starters, isDisabled, useInfo, onClick }) => {
  const { conversations, selectedId } = useAppSelector((state: RootState) => state.conversations_v2);
  return (
    <div className="chat-starter">
      {starters?.map((item, index) => (
        <button
          key={index}
          className={`chat-starter-item ${isDisabled ? 'disabled' : ''}`}
          onClick={() => {
            if (!isDisabled) onClick(item);
          }}
        >
          <span className="name">{item}</span> <Icon name="send" />
        </button>
      ))}
      {useInfo && conversations[selectedId].messages.data.length > 1 ? <NewChatPrompt /> : null}
    </div>
  );
};
